import React from "react";

type IncremnetDecrementIconProps = React.SVGProps<SVGSVGElement>;

export const IncremnetDecrementIcon = ({
  width = 24,
  height = 24,
  ...props
}: IncremnetDecrementIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17 16L12 21L7 16"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 8L12 3L7 8"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default IncremnetDecrementIcon;
